module.exports = __webpack_public_path__ + "img/btn-announce.48432a2d.svg";